import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
            视频精选
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {mediaData.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaData.items.map((item) => (
            <a
              key={item.title}
              href={item.link}
              className="group bg-background-50 rounded-lg overflow-hidden no-underline block"
            >
              <div className="relative w-full h-[180px] overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-background-50/90 rounded-full">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-1.5 py-0.5 bg-background-50/90 text-foreground-700 text-xs rounded">
                  {item.duration}
                </span>
                <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900 line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}